export class Constants {
    public static lastAccessDateInEpoch: number;
}
